import Icon from './Icon';
import styles from './Avatar.module.css';

export type AvatarProps = {
  nome?: string;
  tamanho?: number;
};

export default function Avatar({ nome, tamanho }: AvatarProps) {
  const lado = tamanho ?? 36;
  const iniciais = (nome ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((parte) => parte.charAt(0).toUpperCase())
    .join('');

  return (
    <div
      className={styles.avatar}
      style={{ width: lado, height: lado, fontSize: Math.round(lado * 0.36) }}
    >
      {iniciais || <Icon nome="person" tamanho={Math.round(lado * 0.55)} />}
    </div>
  );
}
